// extracted by mini-css-extract-plugin
export default {"root":"DragHandle_root__XKqHt"};